module.exports = __webpack_public_path__ + "static/media/coin.bb726a44.png";